export const DISPLAY_RESULTS_PROPERTY_TYPE_ID = "370";